<template>
  <v-container class="product-detail-page" :class="{ 'pb-footer': $isMobile() }">
    <div v-if="tmpProduct" class="product-detail-wrap">
      <go-back :routeName="previousPage" close></go-back>
      <v-row>
        <v-col :cols="colProducto">
          <v-card
        class="mx-auto product-detail-card"
        flat
        >
        <v-img
        v-if="!hasNoImage"
        :src="tmpProduct.detalle.srcImg"
        :lazy-src="tmpProduct.detalle.srcImg"
        :alt="tmpProduct.nombre"
        height="320px"
        contain
        class="product-hero"
        ></v-img>

        <div class="px-4 pt-4">
          <div v-if="tmpProduct.esMasVendido && !esAgotado" class="best-seller mb-2">
            <v-icon small color="teal">mdi-star</v-icon>
            <span>Más vendido</span>
          </div>
          <v-chip
            v-if="esAgotado"
            small
            label
            color="error"
            dark
            class="mb-2 agotado-chip"
          >Agotado</v-chip>
          <h1 class="product-name">{{ tmpProduct.nombre }}</h1>
          <p v-if="tmpProduct.detalle.Descripcion && tmpProduct.detalle.Descripcion !== ''" class="product-desc">
            {{ tmpProduct.detalle.Descripcion }}
          </p>
          <div v-if="tmpProduct.Descuentos.length > 0 || tmpProduct.GrupoDescuento" class="price-block">
            <span class="price-main">$ {{ descuento }}</span>
            <del class="price-old">${{ tmpProduct.PrecioUnitario }}</del>
          </div>
          <div v-else class="price-block">
            <span class="price-main">$ {{ tmpProduct.PrecioUnitario }}</span>
          </div>
        </div>

        <template v-if="tmpProduct.esSeleccion">
          <div class="option-section">
            <div class="option-header">
              <span class="option-title">Presentaciones</span>
              <v-chip x-small class="req-chip">Requerido</v-chip>
            </div>
            <div class="option-hint">Elegí 1 opción</div>
            <div class="option-body">
              <seleccion :opciones="tmpProduct.productos"
              @onSeleccionChange="customProduct.totalPrice = $event"></seleccion>
            </div>
          </div>
        </template>

        <template v-if="tmpProduct.esCombinado">
          <div
            v-for="(grupoOpcional, i) in tmpProduct.radioButtons"
            :key="`grupoOpcional_${i}`"
            class="option-section">
            <div class="option-header">
              <span class="option-title">{{ grupoOpcional.nombre }}</span>
              <v-chip x-small class="req-chip">Requerido</v-chip>
            </div>
            <div class="option-hint">Elegí 1 opción</div>
            <div class="option-body">
              <opcionales :opcionales="grupoOpcional.productos"
              @removeItem="removeCustomItem($event)"
              :llevaImporte="grupoOpcional.LlevaImporte"
              @addItem="addCustomItem($event)"
              @restarImporte="customProduct.totalPrice -= $event"
              @sumarImporte="customProduct.totalPrice += $event">
              </opcionales>
            </div>
          </div>
          <div v-for="(grupoCheckbox, i) in tmpProduct.checkBox"
            :key="`grupoCheckbox_${i}`"
            class="option-section">
            <div class="option-header">
              <span class="option-title">{{ grupoCheckbox.nombre }}</span>
              <v-chip x-small :class="grupoCheckbox.ExigeCantidadExacta || grupoCheckbox.CantMinima > 0 ? 'req-chip' : 'opt-chip'">
                {{ grupoCheckbox.ExigeCantidadExacta || grupoCheckbox.CantMinima > 0 ? 'Requerido' : 'Opcional' }}
              </v-chip>
            </div>
            <div class="option-hint">
              <span v-if="grupoCheckbox.CantMaxima > 0 && grupoCheckbox.ExigeCantidadExacta">
                Elegí exactamente {{ grupoCheckbox.CantMaxima }}{{ grupoCheckbox.LlevaCantidad ? ' (podés repetir el mismo)' : '' }}
                · Seleccionado: {{ getSelectedCountByGroup(grupoCheckbox.GuidProducto) }} / {{ grupoCheckbox.CantMaxima }}
              </span>
              <span v-else-if="grupoCheckbox.CantMaxima > 0">
                Hasta {{ grupoCheckbox.CantMaxima }} (opcional){{ grupoCheckbox.LlevaCantidad ? ' · podés repetir el mismo' : '' }}
                · Seleccionado: {{ getSelectedCountByGroup(grupoCheckbox.GuidProducto) }} / {{ grupoCheckbox.CantMaxima }}
              </span>
              <span v-else>
                Elegí una o más opciones · Seleccionado: {{ getSelectedCountByGroup(grupoCheckbox.GuidProducto) }}
              </span>
            </div>
            <div class="option-body">
              <combinados :productos="grupoCheckbox.productos"
              :cantidadMaxima="grupoCheckbox.CantMaxima"
              :cantidadMinima="grupoCheckbox.CantMinima"
              :llevaCantidad="grupoCheckbox.LlevaCantidad"
              :llevaImporte="grupoCheckbox.LlevaImporte"
              :llevaPrecioMitad="grupoCheckbox.LlevaPrecioMitad"
              @updateCustomItem="addCustomItems"
              :grupo="grupoCheckbox.GuidProducto"
              @restarImporte="customProduct.totalPrice -= $event"
              @sumarImporte="customProduct.totalPrice += $event">
              </combinados>
            </div>
          </div>
          <estaticos :estaticos="tmpProduct.estaticos"></estaticos>
        </template>
        <v-card-text>
          <v-textarea v-model="customProduct.obs" label="Observaciones" outlined height="75" hide-details></v-textarea>
        </v-card-text>
        <v-card-actions v-if="!$isMobile()" class="px-4 pb-4">
          <div class="qty-pill mr-3">
            <v-btn icon small :disabled="esAgotado || customProduct.cant <= 1" @click="decreaseQty">
              <v-icon>mdi-minus</v-icon>
            </v-btn>
            <span class="qty-value">{{ customProduct.cant }}</span>
            <v-btn icon small :disabled="esAgotado" @click="increaseQty">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
          <v-btn
            color="primary"
            rounded
            large
            @click="buy"
            :disabled="esAgotado || !(validarRadioButtons && validarCantidadCheckbox)"
          >
            {{ esAgotado ? 'Agotado' : `Agregar $${precioLinea}` }}
          </v-btn>
        </v-card-actions>
      </v-card>
        </v-col>
        <v-col v-if="!$isMobile()" :cols="colProducto">
          <h4>Mi pedido</h4>
          <cart-details></cart-details>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <combinados-con :producto-id="tmpProduct.id"></combinados-con>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-skeleton-loader type="image"></v-skeleton-loader>
    </div>
    <product-footer
      v-if="$isMobile()"
      :disabledProduct="esAgotado || !(validarRadioButtons && validarCantidadCheckbox)"
      :agotado="esAgotado"
      :cantidad="customProduct.cant"
      :precioTotal="precioLinea"
      @add-product="buy"
      @increase="increaseQty"
      @decrease="decreaseQty"
    ></product-footer>
  </v-container>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import GoBack from '../components/GoBack.vue'
import Estaticos from '../components/products/Estaticos.vue'
import Opcionales from '../components/products/Opcionales.vue'
import Seleccion from '../components/products/Seleccion.vue'
import Combinados from '../components/products/Combinados.vue'
import CombinadosCon from '../components/products/CombinadosCon.vue'
import CartDetails from '../components/dialogs/CartDetails.vue'
import descuentoHelper from '@/helpers/descuentosHelper.js'
import ProductFooter from '../components/mobile/ProductFooter.vue'
import { goBackToCatalog, peekCatalogPosition } from '@/helpers/catalogScroll.js'
import { isProductoAgotado } from '@/helpers/productoAgotado.js'
import { applyProductSeo } from '@/helpers/seoHelper.js'

export default {
  components: { GoBack, Seleccion, Opcionales, Estaticos, Combinados, CombinadosCon, CartDetails, ProductFooter },
  name: 'Producto',
  computed: {
    ...mapState('App', ['tiendaActual', 'appLogo']),
    esAgotado () {
      return isProductoAgotado(this.tmpProduct)
    },
    descuento () {
      return descuentoHelper.precioConDescuento(this.tmpProduct)
    },
    colProducto () {
      return this.$isMobile() ? '12' : '6'
    },
    hasNoImage () {
      return this.tmpProduct && this.tmpProduct.detalle && this.tmpProduct.detalle.srcImg && this.tmpProduct.detalle.srcImg.includes('noimage_Producto.png')
    },
    precioUnitarioActual () {
      if (!this.customProduct) return 0
      return Number(this.customProduct.totalPrice) || 0
    },
    precioLinea () {
      return (this.precioUnitarioActual * (Number(this.customProduct.cant) || 1)).toFixed(2)
    },
    validarRadioButtons () {
      if (!this.tmpProduct || !this.tmpProduct.radioButtons) return true
      if (this.tmpProduct.radioButtons.length === 0) return true
      const arrayBooleano = []
      const radioButtonsGroups = this.tmpProduct.radioButtons.map(e => e.productos.map(f => f.id))
      const productosSeleccionados = this.customProduct.items.map(e => e.id)
      for (const index in radioButtonsGroups) {
        const radioButton = radioButtonsGroups[index]
        let validado = false
        for (const product in radioButton) {
          if (productosSeleccionados.includes(radioButton[product])) {
            validado = true
          }
        }
        arrayBooleano.push(validado)
      }
      return arrayBooleano.reduce((a, b) => a && b)
    },
    validarCantidadCheckbox () {
      if (!this.customProduct) return false
      if (!this.tmpProduct || !this.tmpProduct.checkBox) return true
      let validado = true
      const itemsConGrupo = this.customProduct.items.filter(i => i.grupo !== undefined)

      this.tmpProduct.checkBox.forEach((grupo) => {
        const cantSeleccionada = itemsConGrupo
          .filter(i => i.grupo === grupo.GuidProducto)
          .reduce((a, b) => a + (Number(b.cant) || 0), 0)
        const max = Number(grupo.CantMaxima) || 0
        const min = Number(grupo.CantMinima) || 0

        if (max > 0 && cantSeleccionada > max) {
          validado = false
          return
        }
        if (grupo.ExigeCantidadExacta) {
          if (max > 0 && cantSeleccionada !== max) validado = false
        } else if (min > 0 && cantSeleccionada < min) {
          validado = false
        }
      })
      return validado
    }
  },
  methods: {
    ...mapActions('Productos', ['getProductById']),
    ...mapActions('Carrito', ['addItem', 'removeItem']),
    increaseQty () {
      this.customProduct.cant = (Number(this.customProduct.cant) || 1) + 1
    },
    decreaseQty () {
      if ((Number(this.customProduct.cant) || 1) <= 1) return
      this.customProduct.cant = Number(this.customProduct.cant) - 1
    },
    buy () {
      if (this.esAgotado) return
      this.addItem(this.customProduct)
      const code = this.$clientCode()
      const fallback = this.mesaId
        ? { name: 'MesaQRProductos', params: { client: code, mesaId: this.mesaId } }
        : { name: 'Home', params: { client: code } }
      goBackToCatalog(this.$router, fallback)
    },
    async getProduct () {
      this.tmpProduct = await this.getProductById(this.id)
      this.customProduct.id = this.tmpProduct.id
      this.customProduct.nombre = this.tmpProduct.nombre
      this.customProduct.totalPrice = this.tmpProduct.PrecioUnitario * this.tmpProduct.cant
      this.customProduct.tipo = this.tmpProduct.tipo
      this.customProduct.esSeleccion = this.tmpProduct.esSeleccion
      this.customProduct.esCombinadoCombo = this.tmpProduct.esCombinado
      this.customProduct.detalle.srcImg = this.tmpProduct.detalle.srcImg
      this.customProduct.cant = 1
      if (this.tmpProduct.esCombinado) {
        const gruposRequeridos = this.tmpProduct.checkBox.filter((chk) =>
          (Number(chk.CantMinima) || 0) > 0 || chk.ExigeCantidadExacta === true
        )
        this.customProduct.cantidadMinimaPorGrupo = gruposRequeridos.map((chk) => {
          return {
            name: chk.GuidProducto,
            quantity: chk.ExigeCantidadExacta ? (chk.CantMaxima || chk.CantMinima) : chk.CantMinima,
            max: chk.CantMaxima,
            exacta: chk.ExigeCantidadExacta !== false
          }
        })
      }
      this.appendEstaticosToItems()
      this.customProduct.detalle.categoriaId = this.tmpProduct.detalle.categoriaId
      this.customProduct.Descuentos = this.tmpProduct.Descuentos
      this.customProduct.GrupoDescuento = this.tmpProduct.GrupoDescuento
      this.applyProductPageSeo()
    },
    applyProductPageSeo () {
      if (!this.tmpProduct) return
      const code = this.$clientCode && this.$clientCode()
      const img = this.hasNoImage ? undefined : (this.tmpProduct.detalle && this.tmpProduct.detalle.srcImg)
      applyProductSeo({
        productName: this.tmpProduct.nombre,
        storeName: this.tiendaActual,
        description: this.tmpProduct.detalle && this.tmpProduct.detalle.Descripcion,
        image: img || this.appLogo || undefined,
        clientCode: code || this.$route.params.client,
        productId: this.tmpProduct.id || this.id
      })
    },
    removeCustomItem (item, callBack) {
      if (this.customProduct.items.filter(e => e.id === item.id).length > 0) {
        this.customProduct.items = this.customProduct.items.filter(e => e.id !== item.id)
      }
      if (callBack) callBack()
    },
    addCustomItem (item) {
      this.removeCustomItem(item, () => {
        this.customProduct.items.push(item)
      })
    },
    addCustomItems (payload) {
      if (this.customProduct.items.filter(e => e.grupo === payload.grupo).length > 0) {
        this.customProduct.items = this.customProduct.items.filter(e => e.grupo !== payload.grupo || e.grupo === undefined)
      }
      this.customProduct.items = this.customProduct.items.concat(payload.items)
    },
    appendEstaticosToItems () {
      if (this.tmpProduct.estaticos && this.tmpProduct.estaticos.length > 0) {
        for (let i = 0; i < this.tmpProduct.estaticos.length; i++) {
          const idsEstaticos = this.tmpProduct.estaticos[i].productos.map((e) => e.id)
          if (this.customProduct.items.filter((e) => idsEstaticos.includes(e.id)).length === 0) {
            this.customProduct.items = this.customProduct.items.concat(this.tmpProduct.estaticos[i].productos.map((e) => {
              return {
                id: e.id,
                nombre: e.nombre,
                esCombinado: false,
                esSimple: false,
                esSeleccion: false,
                esRadioButton: false,
                esCheckBox: false,
                esEstatico: true,
                cant: e.CantMinima,
                PrecioUnitario: e.PrecioUnitario,
                habilitado: e.habilitado
              }
            }))
          }
        }
      }
    },
    getSelectedCountByGroup (groupGuid) {
      if (!this.customProduct || !this.customProduct.items) return 0
      const itemsDelGrupo = this.customProduct.items.filter(i => i.grupo === groupGuid)
      if (itemsDelGrupo.length === 0) return 0
      return itemsDelGrupo.reduce((a, b) => a + (Number(b.cant) || 0), 0)
    }
  },
  props: ['id', 'mesaId'],
  async mounted () {
    await this.getProduct()
  },
  data () {
    const saved = peekCatalogPosition()
    let previousPage
    if (saved && saved.name) {
      previousPage = { name: saved.name, params: saved.params || {}, query: saved.query || {} }
    } else if (this.mesaId) {
      previousPage = { name: 'MesaQRProductos', params: { mesaId: this.mesaId } }
    } else {
      const code = this.$route.params.client
      previousPage = { name: 'Home', params: { client: code } }
    }
    return {
      tmpProduct: null,
      customProduct: {
        id: 0,
        tipo: null,
        cant: 1,
        nombre: '',
        items: [],
        esCombinadoCombo: false,
        esSeleccion: false,
        totalPrice: 0,
        cantidadMinimaPorGrupo: [],
        detalle: {
          categoriaId: null,
          srcImg: null
        },
        obs: null,
        Descuentos: [],
        GrupoDescuentos: []
      },
      previousPage
    }
  },
  watch: {
    async id () {
      this.customProduct = {
        id: 0,
        tipo: null,
        cant: 1,
        nombre: '',
        items: [],
        esCombinadoCombo: false,
        esSeleccion: false,
        totalPrice: 0,
        cantidadMinimaPorGrupo: [],
        detalle: {
          categoriaId: null,
          srcImg: null
        },
        obs: null
      }
      this.tmpProduct = null
      await this.getProduct()
    }
  }
}
</script>
<style scoped>
.product-detail-page.pb-footer {
  padding-bottom: 110px;
}
.product-detail-wrap {
  position: relative;
}
.product-detail-card {
  overflow: hidden;
}
.product-hero {
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  background: #fafafa;
}
.product-name {
  font-size: 1.5rem;
  font-weight: 800;
  line-height: 1.2;
  margin: 0;
}
.agotado-chip {
  font-weight: 800 !important;
  letter-spacing: 0.02em !important;
}
.product-desc {
  color: rgba(0, 0, 0, 0.55);
  margin: 8px 0 0;
  line-height: 1.4;
}
.price-block {
  margin-top: 12px;
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.price-main {
  font-size: 1.75rem;
  font-weight: 800;
}
.price-old {
  color: rgba(0, 0, 0, 0.45);
}
.best-seller {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #00897b;
  font-size: 0.85rem;
  font-weight: 600;
}
.option-section {
  margin-top: 12px;
  background: #f7f7f7;
  border-radius: 12px;
  overflow: hidden;
}
.option-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px 0;
  gap: 8px;
}
.option-title {
  font-weight: 700;
  font-size: 1.05rem;
}
.option-hint {
  padding: 4px 16px 0;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.5);
}
.option-body {
  padding: 4px 16px 8px;
}
.req-chip {
  background: rgba(0, 0, 0, 0.08) !important;
  font-weight: 600 !important;
}
.opt-chip {
  background: transparent !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  font-weight: 600 !important;
}
.qty-pill {
  display: flex;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 999px;
  padding: 2px 4px;
  min-width: 110px;
  justify-content: space-between;
}
.qty-value {
  font-weight: 700;
  min-width: 24px;
  text-align: center;
}
</style>
